import { NotFound404 } from '@backrs_ui/common-ui';

import { useNuggetRedirect } from '@backrs_ui/grow-ui/src/hooks/useNuggetRedirect';

export const NotFound404Page = () => {
  useNuggetRedirect();

  return <NotFound404 />;
};
